<div *ngIf="selectedIndex === 0">
  <wk-upload-image [mediaType]="'image'"></wk-upload-image>
</div>
<div *ngIf="selectedIndex === 1">
  <wk-upload-image [mediaType]="'audio'"></wk-upload-image>
</div>
<div *ngIf="selectedIndex === 2">
  <wk-upload-image [mediaType]="'video'"></wk-upload-image>
</div>
